import "typeface-cantata-one";
import "typeface-montserrat";
import "./src/styles/globalStyles.css";
import "./src/styles/prism-a11y-dark.css";
